import styled from 'styled-components'

export const Informations = styled.div`
  height: 110px;
  margin: 0px 0px 0px 21px;
`

export const Item = styled.div`
  padding: ${props => (props.margin ? props.padding : '0px')};
  margin: ${props => (props.margin ? props.margin : '0px')};
  display: ${props => (props.display ? props.display : 'block')};
  justify-content: ${props => (props.justify ? props.justify : 'normal')};

  strong {
    padding: 0px;
    font-style: normal;
    font-weight: bold;
    font-size: 32px;
    line-height: 150%;
    color: #2e2d37;
  }
`

export const ZeroStripes = styled.div`
  background-image: url('/assets/img/zero-stripes.svg');
  position: absolute;
  width: 156px;
  height: 122px;
  left: 138px;
  top: 50px;
`

export const AlignHorizontalInfoAreaStamp = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px;

  position: absolute;
  top: 12px;
`

export const Bullet = styled.div`
  position: absolute;
  height: 3.3px;
  width: 3.3px;
  left: -12px;
  top: 6.5px;

  transform: matrix(-1, 0, 0, 1, 0, 0);
`

export const Ellipse = styled.div`
  position: absolute;
  height: 3.33px;
  width: 3.33px;
  background: #696977;
  border: 1px solid transparent;
  border-radius: 50%;

  transform: matrix(-1, 0, 0, 1, 0, 0);
`
